export const fonts = {
    body: "var(--font-inter), system-ui, sans-serif",
};
//# sourceMappingURL=fonts.js.map